import { _export } from './export';
import { statistics } from './statistics';

export const webEvents = {
  export: _export,
  statistics,
};
